import React from 'react';

function Accordion (props) {
  const toggleFAQ = (id) => {
    let faq = document.getElementById(id);
    if (faq.classList.contains('active')) {
      faq.classList.remove('active');
    } else {
      faq.classList.add('active');
    }
  };
  return (
    <div id={props.id} className='faq'>
      <h5 className='faq-title' onClick={() => toggleFAQ(props.id)}>{props.title}</h5>
      <div className='faq-content'>{props.content}</div>
    </div>
  );
}

export default Accordion;
